class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          //new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      console.log(checked_gender);
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    const sfieldsets = Array.from(this.querySelectorAll('.s_optionwrap'));
    const sfieldlen = sfieldsets.length;
    console.log(option_count,fieldlen);
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');
      document.querySelector('.select_size').classList.remove('active');
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.textaddcart');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
/*function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}*/
document.querySelector('.product-addcart').addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      return;
    }else{
      if(typeof load_cart == 'function'){
        cartNotification(response.id);
        load_cart();
        /*setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);*/
      }else{
        window.location.href = "/cart";
      }
      $('.snippet-addto-cart').addClass('successcart');
      setTimeout(function () {
        $('.snippet-addto-cart').removeClass('successcart');
      }, 3000);
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
//variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  //product_slider();
  //variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}
$(document).on('click','.pdp_variant_dropdown',function (e) {
  e.preventDefault();
  $(this).toggleClass('active').parent().siblings().find('.pdp_variant_dropdown').removeClass('active');
  $(this).next('.pdp_variant_dropdownlist').slideToggle().parent().siblings().find('.pdp_variant_dropdownlist').slideUp();
});
$(document).on('change','.pdp_variant_dropdownlist input[type="radio"]',function (e) {
  e.preventDefault();
  $('.pdpvariant_text').text($(this).val());
  $('.pdp_variant_dropdown').removeClass('active');
  $('.pdp_variant_dropdownlist').slideUp();
});
$(document).on('click','.pdp_tablist li a',function (e) {
  e.preventDefault();
  $(this).addClass('active').parent().siblings().find('a').removeClass('active');
  let this_title = $(this).data('title');
  $('.pdp_tabdes [data-title="'+this_title+'"]').addClass('active').siblings().removeClass('active');
  $('.pdp_tabdes').attr('data-tab',$(this).data('tab'));
});
$('body').on('click',function(e){   
  let pdp_variant = $(".pdp_variant_dropdown ,.pdp_variant_dropdownlist");    
  if (!pdp_variant.is(e.target) && pdp_variant.has(e.target).length === 0){
    $('.pdp_variant_dropdown').removeClass('active');
    $('.pdp_variant_dropdownlist').slideUp();
  }
});
$(document).on('click','.choose-selector a',function (e) {
  e.preventDefault();
  $('.select_size').addClass('active');
});
$(document).on('click','.pdp_acco_title',function (e) {
  e.preventDefault();
  $(this).next('.pdpd_acco_desc').slideToggle();
  $(this).toggleClass('active');
});
$(document).on('click','.related_tablist li a',function (e) {
  e.preventDefault();
  $(this).addClass('active').parent('li').siblings().find('a').removeClass('active');
  let this_attr = $(this).attr('href');
  $(this_attr).addClass('active').siblings().removeClass('active');
});
$(document).on('click','.ico-zoom,.zoom-close',function (e) {
  $('body').toggleClass('zoom-open');
});
$(document).on('click','.more_tab',function (e) {
  e.preventDefault();
  $(this).hide();
  $('.pdp_tab').addClass('active');
});
if ($(window).width() < 992) {
  var $carousel = $('.media-grid').flickity({
    pageDots: false,
    wrapAround: true,
    cellAlign: "left",
    contain: true,
    imagesLoaded: true,
    //arrowShape:'M6 0.110001C4.6 1.87 3.1 4.84 2.6 5.5C3.1 6.16 4.6 9.13 6 10.89L5.9 11C4.5 9.24 0.2 5.72 -4.72849e-07 5.5C0.2 5.28 4.5 1.76 5.9 -8.74228e-09L6 0.110001Z'
  });
  var flkty = $carousel.data('flickity');
  console.log(flkty);
  var $carouselStatus = $('.carousel-status');
  function updateStatus() {
    var cellNumber = flkty.selectedIndex + 1;
    $carouselStatus.text( cellNumber + '/' + flkty.slides.length );
  }
  updateStatus();
  $carousel.on( 'change.flickity', updateStatus );
}
//import PinchZoom from 'https://cdn.skypack.dev/pinch-zoom-js@2.3.4'